import { useEffect, useState } from "react";
import { useGetToken } from "../../authConfig";

const SwaggerPage = () => {
    const token = useGetToken();
    const [version, setVersion] = useState("v2");
    const [srcdoc, setSrcdoc] = useState("");

    useEffect(() => {
        if (!token) return;
        setSrcdoc(`<!DOCTYPE html><html><head>
<link rel="stylesheet" href="https://unpkg.com/swagger-ui-dist@5/swagger-ui.css"/>
<style>.swagger-ui table tr:nth-child(odd){background:rgba(255,255,255,.15)}.swagger-ui table tr:nth-child(even){background:rgb(155,155,155,.25)}</style>
</head><body style="margin:0"><div id="ui"></div>
<script src="https://unpkg.com/js-yaml@4/dist/js-yaml.min.js"></script>
<script src="https://unpkg.com/swagger-ui-dist@5/swagger-ui-bundle.js"></script>
<script>
fetch('/api/swagger-spec?version=${version}',{headers:{Authorization:'Bearer ${token}'}})
  .then(async response=>{
    const body=await response.text();
    if(!response.ok){
      throw new Error('Unable to load API definition (HTTP '+response.status+'): '+body);
    }
    return body;
  }).then(yaml=>{
    const spec=jsyaml.load(yaml);
    if(!spec || typeof spec!=='object' || !/^3\\.(0|1|2)\\.\\d+$/.test(spec.openapi)){
      throw new Error('The API definition response does not contain a supported OpenAPI version. Check /api/swagger-spec?version=${version}.');
    }
    const ui=SwaggerUIBundle({
    spec,dom_id:'#ui',
    presets:[SwaggerUIBundle.presets.apis],
  });ui.getSystem().authActions.authorize({BearerAuth:{name:'BearerAuth',schema:{type:'http',scheme:'bearer'},value:'${token}'}});})
  .catch(error=>{
    const message=document.createElement('pre');
    message.style.whiteSpace='pre-wrap';
    message.textContent=error instanceof Error ? error.message : String(error);
    document.getElementById('ui').replaceChildren(message);
  });
</script></body></html>`);
    }, [token, version]);

    return (
        <div style={{ width: "100%", height: "100vh" }}>
            <label htmlFor="swagger-version">API version </label>
            <select id="swagger-version" value={version} onChange={event => setVersion(event.target.value)}>
                <option value="v1">v1 and v1.2</option>
                <option value="v2">v2</option>
                <option value="v3">v3</option>
            </select>
            <iframe key={srcdoc} title={`Swagger UI ${version}`} srcDoc={srcdoc} style={{ width: "100%", height: "calc(100% - 32px)", border: "none" }} />
        </div>
    );
};

export default SwaggerPage;
